import { LookupYesNoType } from '@/api/dtos';
import EConsentContext, { EConsentUserType } from '@/contexts/EConsentContext';
import { useScopedField } from '@ngt/forms-core';
import { DateTime } from 'luxon';
import { FC, useContext, useEffect } from 'react';

const EConsentSignatureUpdater: FC = () => {
    const { userType } = useContext(EConsentContext);

    const {
        state: { value: patientSignedConsent },
        context: { setValue: setPatientSignedConsent },
    } = useScopedField<number>('patientSignedConsent', { value: true }, false, false);
    const {
        state: { value: datePatientSignedConsent },
        context: { setValue: setDatePatientSignedConsent },
    } = useScopedField<string>('datePatientSignedConsent', { value: true }, false, false);
    const {
        state: { value: investigatorSignedConsent },
        context: { setValue: setInvestigatorSignedConsent },
    } = useScopedField<number>('investigatorSignedConsent', { value: true }, false, false);
    const {
        state: { value: dateInvestigatorSignedConsent },
        context: { setValue: setDateInvestigatorSignedConsent },
    } = useScopedField<string>('dateInvestigatorSignedConsent', { value: true }, false, false);

    useEffect(() => {
        const today = DateTime.now().toISODate();

        if (userType === EConsentUserType.Participant) {
            if (!patientSignedConsent) {
                setPatientSignedConsent(LookupYesNoType.Yes, true, true, true, false);
            }

            if (!datePatientSignedConsent) {
                setDatePatientSignedConsent(today, true, true, true, false);
            }
        }

        if (userType === EConsentUserType.Investigator) {
            if (!investigatorSignedConsent) {
                setInvestigatorSignedConsent(LookupYesNoType.Yes, true, true, true, false);
            }

            if (!dateInvestigatorSignedConsent) {
                setDateInvestigatorSignedConsent(today, true, true, true, false);
            }
        }
    }, [
        userType,
        patientSignedConsent,
        datePatientSignedConsent,
        investigatorSignedConsent,
        dateInvestigatorSignedConsent,
        setPatientSignedConsent,
        setDatePatientSignedConsent,
        setInvestigatorSignedConsent,
        setDateInvestigatorSignedConsent,
    ]);

    return null;
};

export default EConsentSignatureUpdater;
